import React from 'react';
import { Card, CardContent, Typography, Divider, Box, Grid, Chip } from '@mui/material';

const EventSummaryCard = ({ event = {}, categoriesMap = {}, divisionsMap = {}, showTitle = true, teamsMap = {} }) => {
    if (!event || !event.event) return null;
    const catEntries = Object.entries(event.categoriesAvg || {});
    const divEntries = Object.entries(event.divisionsAvg || {});

    return (
        <Card sx={{ minWidth: 300 }}>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
                    {showTitle && (
                        <Box>
                            <Typography variant="h6">{event.event.number} - {event.event.name}{event.event.company ? ` - ${event.event.company}` : ''}</Typography>
                            <Typography variant="subtitle2">Affiliated Teams</Typography>
                            {event.event?.associatedTeams && event.event.associatedTeams.length > 0 && (
                                <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                    {event.event.associatedTeams.map((a) => {
                                        const uid = typeof a === 'string' ? a : a.uid;
                                        const t = teamsMap[uid] || {};
                                        const label = t.teamNumber ? `#${t.teamNumber}${t.teamName ? ' - ' + t.teamName : ''}` : (t.teamName || uid);
                                        return <Chip key={uid} label={label} size="small" />;
                                    })}
                                </Box>
                            )}
                        </Box>
                    )}

                    <Box sx={{ textAlign: 'right' }}>
                        <Typography variant="subtitle2">Overall Avg</Typography>
                        <Typography variant="h6">{event.avgOverall ?? '—'}</Typography>
                        <Typography variant="subtitle2">Overall Top</Typography>
                        <Typography variant="h6">{event.overallTopInEvent ?? '—'}</Typography>
                    </Box>
                </Box>

                <Divider sx={{ my: 1 }} />

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="subtitle2">Categories</Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                            {catEntries.length === 0 && <Typography variant="body2">No category data</Typography>}
                            {catEntries.map(([catUid, avg]) => (
                                <Chip key={catUid} label={`${(categoriesMap[catUid] || catUid)}: ${avg ? '~' + avg : '-'} / top ${event.categoryTop?.[catUid] ?? '—'}`} size="small" />
                            ))}
                        </Box>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="subtitle2">Divisions</Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                            {divEntries.length === 0 && <Typography variant="body2">No division data</Typography>}
                            {divEntries.map(([dUid, avg]) => {
                                // compute top for this division excluding excludeScore and scoreMax markers
                                const divisionScores = (event.scores || []).filter(x => x.team.division == dUid && !x.excludeScore && !x.scoreMax).map(x => x.finalScore);
                                const divisionTop = divisionScores.length > 0 ? Math.min(...divisionScores) : '—';
                                return <Chip key={dUid} label={`${(divisionsMap[dUid] || dUid)}: ${avg ? '~' + avg : '—'} / top ${divisionTop}`} size="small" />
                            })}
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default EventSummaryCard;
